import React from 'react';
import { getStatusBadge } from '../../../constants/violationConstants';

/**
 * ТЗ раздел 6: ACTIVE визуально отличается от RESOLVED, но полагаться только
 * на цвет нельзя — код статуса всегда выводится текстом.
 */
const ViolationStatusBadge = ({ status, withLabel = false }) => {
  const badge = getStatusBadge(status);

  return (
    <span className="vio-status">
      <span className={`vio-badge vio-badge--${badge.modifier}`}>{badge.code}</span>
      {withLabel && <span className="vio-status-label">{badge.label}</span>}
    </span>
  );
};

export default ViolationStatusBadge;
